import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  CBadge,
  CContainer,
  CHeader,
  CHeaderBrand,
  CHeaderDivider,
  CHeaderNav,
  CHeaderToggler,
  CImage
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilMenu } from '@coreui/icons'

// Component
import AppBreadcrumb from './AppBreadcrumb'
import AppHeaderDropdown from './header/AppHeaderDropdown'

// Icons
import CloudxierIcon from '../assets/icons/CloudxierLogoInWhite.png'

const AppHeader = () => {
  const dispatch = useDispatch()
  const sidebarShow = useSelector((state) => state.sidebarShow)
  const user = JSON.parse(localStorage.getItem("user"))

  return (
    <CHeader position="sticky" className="mb-4">
      <CContainer fluid>
        <CHeaderToggler
          className="ps-1"
          onClick={() => dispatch({ type: 'set', sidebarShow: !sidebarShow })}
        >
          <CIcon icon={cilMenu} size="lg" />
        </CHeaderToggler>
        <CHeaderBrand className="mx-auto d-md-none" to="/">
          <CImage fluid src={CloudxierIcon} />
        </CHeaderBrand>
        <CHeaderNav className="d-none d-md-flex me-auto">
        </CHeaderNav>
        <CHeaderNav>
        </CHeaderNav>
        <CHeaderNav className="ms-3">
          <div className="d-flex flex-column align-items-end">
            <AppHeaderDropdown />
            <div className='mt-2 me-2'>
              <CBadge
                style={{
                  backgroundColor: '#E8A020',
                  color: 'black',
                  fontSize: '0.75rem',
                  fontWeight: '700',
                  padding: '10px 18px',
                  borderRadius: '6px',
                  letterSpacing: '0.05em',
                  marginTop: '4px',
                }}
              >
                {user?.role_user?.toUpperCase()}
              </CBadge>
            </div>
          </div>
        </CHeaderNav>
      </CContainer>
      <CHeaderDivider />
      <CContainer fluid>
        <AppBreadcrumb />
      </CContainer>
    </CHeader>
  )
}

export default AppHeader
